import { EpimsBaseEntityDto } from './epim-base.dto';
export class SecurityClassificationDto extends EpimsBaseEntityDto {

    SecurityId: string;
    SecurityCodeName: string;
    SecurityClassificationName: string;
    Description: string;
    SubscriberId: string;
    SubscriptionUserId: string;
}
